import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
export const useCreateFolder = () => {
    return useMutation({
        mutationFn: ({ name, parentId }: { name: string; parentId?: string }) =>
            chatService.createFolder(name, parentId),
    });
};

export default useCreateFolder;
